import { useQuery } from '@tanstack/react-query';

import AgreementsServiceClientImpl from 'src/api/agreementsService/client';

import { queryRetry } from '../query-retry';
import { Building } from '../../shared/types/building';

export const useBookingTermsPdfData = (building: Building) => {
    const slug = building.building_slug;

    return useQuery({
        queryKey: ['booking-terms-pdf', slug],
        enabled: Boolean(slug),
        queryFn: async () => {
            const data = await new AgreementsServiceClientImpl().getBookingTermsPdf(slug);
            if (!data) throw new Error('No booking terms PDF data received');

            return `data:application/pdf;base64,${data}`;
        },
        retry: queryRetry,
    });
};
